import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { UserUsageTracking } from '../features/usage/UserUsageTracking.tsx'

const RootLayout = () => {
  return <>
    <Outlet />
    <UserUsageTracking />
    <TanStackRouterDevtools />
  </>
}

export const Route = createRootRoute({ component: RootLayout })
